<script lang="ts" setup>
import { MsgSubscribeInstanceSendHistoryMessageBySystemGET } from '@/api/user-msgInstance/MsgSubscribeInstance'
import config from '@/config'
import envConfig from '@/config/proxy.config'
import { useUserStore } from '@/store/index'
import { Bell } from '@element-plus/icons-vue'
import { SjzyNotice, type SjzyNoticeDataItem } from '@sjzy/library'
import cookie from 'js-cookie'
import QueryString from 'qs'

const userStore = useUserStore()
const tabsStore = useTabsStore()
const router = useRouter()
const mode = import.meta.env.MODE
const token = cookie.get(`${mode}_${config.tokenTableName}`)
const { subSysId, userId } = userStore
const drawerModel = ref(false)
const noticeToken = ref(token?.toString().replace('Bearer ', ''))
const proxyApi = ref(`${envConfig.userApi}/userApi/signalr-hubs/usercentermessage?systemKey=CAMS`)

const msgPath = '/microAppMid/messageSubscription/msgLookMore'

const MICRO_APP_ENVIRONMENT = computed(() => {
  const obj = QueryString.parse(location.search, { ignoreQueryPrefix: true })
  return window.__MICRO_APP_ENVIRONMENT__ || obj.type === 'iframe'
})

/** 站内信的点击去处理事件 */
function handleNotificationClick(msgTypeId?: number) {
  tabsStore.delVisitedRoute(msgPath)

  router.push({
    path: msgPath,
    query: { active: 0, msgTypeId, time: Date.now() },
  })
}
/** 查看所有跳转 */
function handleClickLook(type: SjzyNoticeDataItem['type']) {
  const taskObj: Recordable = {
    msg: 0,
    task: 1,
    flow: 2,
  }

  // 当点击的是单行的时候
  drawerModel.value = false
  router.push({
    path: msgPath,
    query: { active: taskObj[type] },
  })
}

onMounted(() => {
  setTimeout(() => {
    MsgSubscribeInstanceSendHistoryMessageBySystemGET({
      systemId: subSysId as any,
    })
  }, 3000)
})
</script>

<template>
  <div class="VabNotice">
    <SjzyNotice
      v-model:drawer-model="drawerModel"
      class="cursor-pointer"
      :token="noticeToken"
      :proxy-api="proxyApi"
      :sub-sys-id="subSysId"
      :user-id="userId"
      task-click-internel-method
      :is-show-right-bottom-notice="!MICRO_APP_ENVIRONMENT"
      @notification-click="handleNotificationClick"
      @task-all-click="handleClickLook"
    >
      <span class="icon-btn">
        <ElIcon><Bell /></ElIcon>
      </span>
    </SjzyNotice>
  </div>

  <div v-show="false" class="h-70px h-75px p-x-10 p-t-4px p-t-7px" />
</template>

<style lang="scss" scoped>
.VabNotice {
  // margin-right: 3px;
  // color: #fff !default;
  // vertical-align: -1.8px;
}
</style>
